export default __webpack_public_path__ + "static/media/arrow-drop.7461d698.svg";